<template>
  <div class="page-wrapper">
    <!-- #region  header -->
    <div class="order-header">
      <div class="d-flex align-center justify-space-between pl-4 pr-2 py-1" style="height: 64px">
        <v-spacer></v-spacer>
        <div class="text-h6">購買飼料點數</div>
        <v-spacer></v-spacer>
        <v-btn icon color="black" @click="closePage"><v-icon>mdi-close</v-icon></v-btn>
      </div>
    </div>
    <div class="body-bg">
      <div class="body-centent">
        <div>
          <div class="mb-2 gradient-text body-title">購買成功</div>
          <div class="mb-2">
            <v-img :src="img" width="126" height="118" contain></v-img>
          </div>
        </div>

        <div class="token-outer">
          <div class="token-inner">
            <div>
              <v-img :src="tokenIcon" height="55" width="55" contain></v-img>
            </div>
            <div>
              <div>我的{{ beefSummary.tokenTypeName }}</div>
              <div class="d-flex align-end">
                <span class="token-amt">{{ beefSummary.availableQuota }}</span>
                <div class="pl-2 text-right">顆</div>
              </div>
            </div>
            <div>
              <v-btn text color="secondary" height="28" class="px-1" @click="goManage">飼料管理</v-btn>
            </div>
          </div>
          <div class="d-sm-flex justify-space-between py-4" style="width: 100%">
            <div>
              <div>
                <div class="mb-1">{{ orderInfo.createdAt | formatYMD }}</div>
                <!-- <span class="grey--text text--lighten-2 px-2">|</span> -->
                <div class="mb-1">訂單編號：{{ orderInfo.orderNo }}</div>
              </div>
              <div class="d-flex mb-1">
                <div>有效日期：{{ orderInfo.expiryDate | formatYMDHM }}</div>
                <div class="token-status">有效</div>
              </div>
              <div>項&emsp;&emsp;目：購買</div>
            </div>
            <div class="d-flex align-center justify-start mt-2 mt-sm-0" style="height: 30px">
              <div>{{ orderInfo.tokenTypeName }}</div>
              <div class="px-2">
                <v-img :src="this.$icons.token1" width="18" height="18" contain></v-img>
              </div>
              <div class="text-h6 font-weight-medium">{{ orderInfo.amount }}</div>
            </div>
          </div>
        </div>
        <div style="max-width: 460px; width: 100%">
          <v-btn block height="54" color="secondary" rounded @click="backFromWhere"><span class="text-body-1">完成</span></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TokenPurchase_GetUserToken, TokenPurchase_GetUserTokenSummary } from "@/apis/api.js";
import { formatDate } from "@/utils/dateFormat.js";

export default {
  data() {
    return {
      img: require("@/assets/image/member/order_success.svg"),
      tokenIcon: require("@/assets/image/member/Dog Food.png"),
      orderInfo: {},
      beefSummary: {
        tokenTypeCode: "BEEF",
        tokenTypeName: "牛肉飼料",
        totalQuota: 0,
        usedQuota: 0,
        availableQuota: 0,
      },
    };
  },
  filters: {
    // full datetime
    formatYMDHM(value) {
      return formatDate(value, "YYYY-MM-DD HH:mm");
    },
    // date only
    formatYMD(value) {
      return formatDate(value, "YYYY-MM-DD");
    },
  },
  mounted() {
    let query = this.$route.query;

    this.getUserToeknByOrderNo_api(query.oid);

    let email = localStorage.getItem("_signinEmail");
    this.getUserTokenSummary(email);
  },
  methods: {
    /** 飼料管理 */
    goManage() {
      this.$router.push({ name: "Center", query: { tab: "beef" } });
    },
    /** get user 的 總飼料額 */
    getUserTokenSummary(email) {
      TokenPurchase_GetUserTokenSummary(email)
        .then((res) => {
          console.log(res);
          const summaries = res.data;

          const beef = summaries.find((s) => s.tokenTypeCode === "BEEF");
          this.beefSummary = beef;
        })
        .catch((err) => {
          console.error(err.response.data.data);
          const defaultValue = err.response.data.data;
          this.beefSummary = defaultValue;
        })
        .finally();
    },
    /**get 單筆飼料 api */
    getUserToeknByOrderNo_api(orderNo) {
      TokenPurchase_GetUserToken(orderNo)
        .then((res) => {
          console.log(res.data.data);
          this.orderInfo = res.data.data;
        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally(() => {});
    },
    // 關閉分頁
    closePage() {
      if (window.opener) {
        window.close();
      } else {
        this.prePage();
      }
    },
    // 上一頁
    prePage() {
      let from = this.$route.query.from;
      switch (from) {
        case "ai":
          window.location.replace(process.env.VUE_APP_MAIN_AICHAT_BASE_URL);
          break;

        default:
          window.history.back();
          break;
      }
    },
    backFromWhere() {
      // 如果從ai購買算力過來就導回去
      let fromAI = localStorage.getItem("from_ai");
      if (fromAI) {
        localStorage.removeItem("from_ai");
        window.location.href = `${process.env.VUE_APP_MAIN_AICHAT_BASE_URL}/purchase?from_ai=y`;
      } else {
        this.$router.push({ name: "Order" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 滿整個視窗高度 */
}

.body-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--grey-grey-lighten-5, #fafafa);
  height: 100%;
  width: auto;
  padding: 40px 16px 40px 16px;

  .body-centent {
    max-width: 732px;
    width: 100%;
    align-items: center;
    justify-items: center;
  }

  .body-title {
    /* table/pagetitle-l 頁標 */
    font-family: Inter;
    font-size: 25.9px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    /* 38.85px */
  }
}

.token-outer {
  border-radius: 8px;
  padding: 16px;
  background: var(--product-color-TaroWhite, #fff);
  width: 100%;
  margin-bottom: 24px;

  .token-inner {
    border-radius: 4px;
    display: flex;
    padding: 12px 8px 12px 16px;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--spacing-16, 16px);
    align-self: stretch;
    background: linear-gradient(90deg, #e1f5fe 0%, #effff0 52%, #fffce5 100%);
  }
}

.token-status {
  color: var(--light-blue-darken-2, #0288d1);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  /* caption 12/w400 */
  font-family: "Noto Sans TC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 18px */
  letter-spacing: 0.4px;

  margin-left: 8px;
  width: 49px;

  border-radius: 500px;
  background: var(--light-blue-lighten-5, #e1f5fe);
}
</style>
